import { LOG_LEVEL } from '@ottobock/shared/domain';

import { BUILD_ENV, BUILD_VERSION } from '../build-info';

export const environment = {
  apiUrl: 'https://rsu-api-sandbox.ottobock.com/remote-updates',
  production: false,
  allowCompatibilityDowngrade: true,
  isSandbox: true,
  logLevel: LOG_LEVEL.debug,
  buildInfo: {
    environment: BUILD_ENV,
    version: BUILD_VERSION
  },
  authEnv: {
    msalConfig: {
      auth: {
        clientId: 'affecfb3-54d0-4466-b1de-7a5a8794d634',
        redirectUri: 'https://rsu-console-sandbox.ottobock.com/signin-oidc'
      }
    },
    apiConfig: {
      scopes: ['openid', 'affecfb3-54d0-4466-b1de-7a5a8794d634', 'offline_access'],
      uri: 'https://rsu-api-sandbox.ottobock.com/remote-updates'
    },
    b2cPolicies: {
      names: {
        signUpSignIn: 'B2C_1A_MYOB_MFA_signup_signin'
      },
      authorities: {
        signUpSignIn: {
          authority:
            'https://ottobockglobalb2cacceptance.b2clogin.com/ottobockglobalb2cacceptance.onmicrosoft.com/B2C_1A_MYOB_MFA_signup_signin'
        }
      },
      authorityDomain: 'ottobockglobalb2cacceptance.b2clogin.com'
    }
  }
};
